import { render } from "./Provenance.vue?vue&type=template&id=3db337bb&scoped=true"
import script from "./Provenance.vue?vue&type=script&lang=js"
export * from "./Provenance.vue?vue&type=script&lang=js"

import "./Provenance.vue?vue&type=style&index=0&id=3db337bb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3db337bb"]])

export default __exports__